import axios from 'axios';

export const getPlacesData = async (type, sw, ne) => {
  try {

    const url = `https://travel-advisor.p.rapidapi.com/${type}/list-in-boundary`;

    const options = {
      params: {
        bl_latitude: sw.lat, 
        tr_latitude: ne.lat,
        bl_longitude: sw.lng,
        tr_longitude: ne.lng
      },
      headers: {
        'X-RapidAPI-Key': process.env.REACT_APP_RA_API_KEY,
        'X-RapidAPI-Host': 'travel-advisor.p.rapidapi.com'
      }
    };

    const { data: { data }} = await axios.get(url, options);

    return data;

  } catch (error) {
    console.log(error);
  }
};

export const getWeatherData = async (lat, lng) => {
  try {

    const url = 'https://community-open-weather-map.p.rapidapi.com/find';

    const options = {
      params: {
        lon: lng,
        lat: lat,
      },
      headers: {
        'X-RapidAPI-Key': process.env.REACT_APP_RA_API_KEY,
        'X-RapidAPI-Host': 'community-open-weather-map.p.rapidapi.com'
      }
    };

    const { data } = await axios.get(url, options);

    return data;

  } catch (error) {
    console.log(error);
  }
};